import type GroupLevel from '@/Pages/GenericWorklist/Components/GroupLevel';
import { convertToValidDate } from '@/Helpers/DateHelpers';
import { WORKLIST_FILTER_DATE_FIELDS, type Worklist, type WorklistFilterParams } from './WorklistParams';

export type CustomWorklistDTO = CustomWorklist;

export interface UserConfig {
    IsSidebarCollapsed: boolean;
}

export interface CustomWorklist {
    CreatedByID: number;
    Description?: string;
    GroupID?: number;
    GroupLevel: GroupLevel;
    ID: number;
    LastModifiedByID: number;
    Name: string;
    Version: string;
    Worklist: Worklist;
    UserConfig: UserConfig | null;
}

const normalizeFilterDates = (filter: WorklistFilterParams | undefined): WorklistFilterParams | undefined => {
    if (!filter) {
        return filter;
    }

    const normalized: WorklistFilterParams = { ...filter };
    for (const field of WORKLIST_FILTER_DATE_FIELDS) {
        const value = normalized[field];
        if (value === undefined || value === null) {
            continue;
        }
        (normalized[field] as Date | undefined) = convertToValidDate(value as Date | string);
    }

    return normalized;
};

export const normalizeWorklistDates = (worklist: Worklist): Worklist => ({
    ...worklist,
    Params: {
        ...worklist.Params,
        Filter: normalizeFilterDates(worklist.Params.Filter),
    },
});

export const mapDTOToCustomWorklist = (dto: CustomWorklistDTO): CustomWorklist => {
    return {
        ...dto,
        Worklist: normalizeWorklistDates(dto.Worklist),
    };
};

export const mapCustomWorklistToDTO = (customWorklist: CustomWorklist): CustomWorklistDTO => {
    return {
        ...customWorklist,
    };
};

export default CustomWorklistDTO;
